<template>
  <section class="sl-category-item-list" :class="{'in-basket': isInBasket}">
    <header>
      <div class="name">{{ category.name }}</div>
      <div class="total"><amt-cents :cents="totalCents" :is-estimate="hasItemsWithoutPrice" v-if="totalCents" /></div>
    </header>
    <div class="sl-item-list">
      <needed-item-entry v-for="item in categoryItems" :key="item.id" :item="item" :is-in-basket="isInBasket" />
    </div>
  </section>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ListSection',
  props: {
    category: { type: Object, required: true },
    categoryItems: { type: Array, required: true },
    isInBasket: { type: Boolean, required: false }
  },
  computed: {
    hasItemsWithoutPrice () {
      return _.some(this.categoryItems, i => i.hasNoPrice)
    },
    totalCents () {
      return _.reduce(this.categoryItems, (total, i) => {
        return total + i.totalPriceCents
      }, 0)
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  .sl-category-item-list {
    margin-bottom: 1rem;

    header {
      color: darken($light-color, 15%);
      font-size: 1.1rem;
      display: flex;
      flex-direction: row;

      .name {
        flex: 1 0 80%;
      }

      .total {
        flex: 0 0 20%;
        text-align: right;
        padding-right: 0.25rem;
        opacity: 0.5;
      }
    }

    .sl-item-list {
    }

    &.in-basket {
      header {
        color: lighten($dark-color, 25%);
      }
      .sl-item-list {
      }
    }
  }
</style>
